import { useEffect } from "react";

import styled from "styled-components/macro";

import { motion } from "framer-motion";

import FnrIcon from "UI/FnrIcon";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap";

import { ActionButton } from "../ActionButton";
import { useCTAContext } from "../CTA";
import { useOnCTAClick } from "../stateHooks";

import PlaceholderTitle from "./PlaceholderTitle";

export default function Message({ action, setAction, ...props }) {
  const onCTAClick = useOnCTAClick();
  const { link } = useCTAContext();

  useEffect(() => {
    if (link) {
      if (typeof action === "undefined" || action === null)
        setAction("Take Me There");
    }
  }, [action, link, setAction]);
  if (link)
    return (
      <SDiv onClick={onCTAClick} data-cy="Message_Link">
        <MessageContent {...props} />
        {action && <ActionButton action={action} />}
      </SDiv>
    );
  return <MessageContent {...props} />;
}

function MessageContent({ title, description, image, icon }) {
  const { isPreview } = useCTAContext();

  return (
    <>
      {icon && (
        <Icon>
          <IconInside>
            <FnrIcon icon={icon} />
          </IconInside>
        </Icon>
      )}
      <Wrapper>
        <TextContent>
          <FnrHorizontalGap gap={0}>
            <Title>{title}</Title>
            <PlaceholderTitle show={isPreview && !title} />
          </FnrHorizontalGap>
          {description && <Description>{description}</Description>}
        </TextContent>
        {image && <ImageContent style={{ backgroundImage: `url(${image})` }} />}
      </Wrapper>
    </>
  );
}

const Icon = styled.div`
  position: absolute;
  color: #fff;
  font-size: 220px;
  height: 100%;
  left: 0;
  overflow: hidden;
  padding: 0 40px;
  display: flex;
  align-items: center;
  opacity: 0.15;
  max-width: 100%;
  border-radius: 24px;
  box-sizing: border-box;
  justify-content: center;
`;
const IconInside = styled.div`
  transform: rotate(-6deg);
`;
const Wrapper = styled.div`
  padding: 16px;
  display: flex;
  align-items: stretch;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  z-index: 10;
  word-break: break-word;
`;
const Title = styled.div`
  font-weight: 600;
  font-size: 20px;
`;
const Description = styled.div`
  font-weight: 400;
`;
const TextContent = styled(motion.div)`
  flex-grow: 1;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const ImageContent = styled.div`
  aspect-ratio: 1;
  background: #fff;
  flex-shrink: 0;
  border-radius: 12px;
  margin-top: -4px;
  margin-right: -4px;
  height: calc(100% + 8px);
  background-size: cover;
  background-position: center center;
`;
const SDiv = styled.div`
  text-decoration: none !important;
  color: inherit;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin: 8px 8px 40px 8px;
`;
